import React from "react";
import { View, TouchableNativeFeedback, StyleSheet } from "react-native";
import Text from "@components/AppText";
import { normalize } from "./metrics";
import WhatsappDefault from "../../assets/svg/WhatsappDefault";

const ShareOnWA = ({
  width = normalize(100),
  onPress = () => {},
  showCTA = true,
  paddingBottom = 15,
}) => (
  <View style={{ paddingBottom }}>
    <TouchableNativeFeedback onPress={onPress}>
      <View style={[styles.wrapper, { width: normalize(width) }]}>
        <View
          style={{
            paddingRight: !showCTA ? 0 : 6,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <WhatsappDefault />
        </View>
        {showCTA && (
          <View
            style={{
              alignItems: "center",
              justifyContent: "center",
              // backgroundColor: "brown",
            }}
          >
            <Text
              bold
              style={{
                color: "rgba(0, 0, 0, 0.86)",
                fontSize: normalize(13),
              }}
            >
              शेयर करें
            </Text>
          </View>
        )}
      </View>
    </TouchableNativeFeedback>
  </View>
);

const styles = StyleSheet.create({
  wrapper: {
    borderRadius: 6,
    borderWidth: 1,
    borderColor: "#075E54",
    flexDirection: "row",
    alignItems: "stretch",
    height: normalize(30),
    overflow: "hidden",
    marginRight: 1,
    justifyContent: "center",
  },
});

export default ShareOnWA;
